import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "reviewComment",
  class: "form-label"
}, "Comment", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Reject")
], -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "reviewStatus",
  class: "form-label"
}, "Status", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Select Status", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "IF" }, "Reject Incident", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "IP" }, "Accept Incident", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "reviewComment",
  class: "form-label"
}, "Comment", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Save")
], -1)
const _hoisted_15 = { class: "border-bottom mb-3" }
const _hoisted_16 = { class: "mb-3 row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "uploadNarrative",
    class: "col-form-label"
  }, "File:")
], -1)
const _hoisted_18 = { class: "col-md-8" }
const _hoisted_19 = { class: "d-grid gap-2 d-md-flex justify-content-md-end" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "No", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, "Incidents", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search pe-1" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "ms-2 filter-description"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "bi bi-info-circle-fill text-info"
}
const _hoisted_27 = {
  key: 1,
  class: "bi bi-info-circle-fill text-info"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["href"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = ["onClick"]

import BTable from "../BTable/BTable.vue";
import BTableHeader from "../BTable/BTableHeader.vue";
import { BTableOptions, BTableColumn } from "../BTable/BTable.types";
import BFilterModal from "../BFilterEditor/BFilterModal.vue";
import InformationModal from "../Misc/InformationModal.vue";
import AuditJobs from "./AuditJobs.vue";

import {
    BFilterOptions,
    describeFilters,
} from "../BFilterEditor/BFilterEditor.types";
import { computed, onMounted, reactive, ref } from "vue";
import { useAuditIncidentStore } from "@/stores/auditIncidentStore";
import { object, string } from "yup";
import { Audit, AuditReviewDocument } from "@/audit.types";
import { useFormValidation } from "@/validation";
import { debounce } from "vue-debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditDetailsIncidents',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

var updateData = debounce(() => getData(), "15000ms");

const isShowFilterEditor = ref(false);

const isShowUploadNarrative = ref(false);
const selectedIncindentId = ref(0);
const uploadNarrativeTitle = ref("");
const isConfirmDialog = ref(false);

const auditIncidentStore = useAuditIncidentStore();

const hideUploadNarrative = function () {
    isShowUploadNarrative.value = false;
};

const showUploadNarrative = function (incident) {
    isShowUploadNarrative.value = true;
    selectedIncindentId.value = incident.id;
    uploadNarrativeTitle.value = `Upload Narrative for incident ${incident.incidentNumber}`;
    return false;
};

const hasAppliedFilters = ref(false);
const columns = reactive<BTableColumn[]>([
    {
        key: "incidentNumber",
        text: "Incident Number",
        sortable: true,
        value: (item) => item["incidentNumber"],
    },
    {
        key: "incidentType",
        text: "Type",
        sortable: true,
        value: (item) => item.type,
    },
    {
        key: "incidentDate",
        text: "Incident/Arrest Date",
        sortable: true,
        value: (item) => item["date"],
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["statusName"],
    },
    {
        key: "actions",
        text: "",
        columnClass: ["text-end"],
        class: (item) => ["text-nowrap text-end"],
        sortable: false,
        value: (item) => 2,
    },
]);

const { handleSubmit, errors } = useFormValidation();
const uploadNarrative = ref<File | null>();

const showFilterEditor = function (event: any) {
    event.preventDefault();
    isShowFilterEditor.value = true;
};
const handleDismiss = function () {
    isShowFilterEditor.value = false;
};

const filtersDescription = computed(() => {
    if (auditIncidentStore.filterOptions == null) {
        return "";
    }
    return describeFilters(
        auditIncidentStore.filterOptions.filters,
        auditIncidentStore.filterableFields
    );
});

const isShowNarrativeReviewEditor = ref(false);

const showNarrativeReviewEditor = function (id: number) {
    review.value = { status: "" } as AuditReviewDocument;
    selectedIncindentId.value = id;
    isShowNarrativeReviewEditor.value = true;
};

const hideNarrativeReviewEditor = () => {
    isShowNarrativeReviewEditor.value = false;
};

const isShowIncidentReviewEditor = ref(false);

const showIncidentReviewEditor = function (id: number) {
    selectedIncindentId.value = id;
    review.value = { status: "" } as AuditReviewDocument;
    isShowIncidentReviewEditor.value = true;
};

const hideIncidentReviewEditor = () => {
    isShowIncidentReviewEditor.value = false;
};
const reviewIncident = async function () {
    if (await handleSubmit(reviewSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewIncident(review.value);
        hideIncidentReviewEditor();
        await getData();
    }
};

const reviewSchema = object<AuditReviewDocument>({});

const review = ref({} as AuditReviewDocument);

const reviewNarrative = async function () {
    if (await handleSubmit(reviewSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewNarrative(review.value);
        hideNarrativeReviewEditor();
        await getData();
    }
};

const checkIncidentsVersion = async function () {
    await auditIncidentStore.checkIncidentsVersion(props.id);
    await getData();
};

const hideConfirmDialog = async function () {
    isConfirmDialog.value = false;
};
const deleteIncident = async function () {
    await auditIncidentStore.deleteItem(selectedIncindentId.value);
    await getData();
    await hideConfirmDialog();
};
const deleteItem = async function (id: number) {
    selectedIncindentId.value = id;
    isConfirmDialog.value = true;
};

const handleOptionChange = async function (options: BTableOptions) {
    if (options) {
        auditIncidentStore.tableOptions = options;
    }
    await getData();
};

const resetFilters = async function () {
    if (auditIncidentStore.filterOptions != null) {
        auditIncidentStore.filterOptions.filters = [];

        await getData();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
};

const applyFilters = async function (newFilterOptions: BFilterOptions) {
    auditIncidentStore.filterOptions = newFilterOptions;
    isShowFilterEditor.value = false;
    hasAppliedFilters.value =
        auditIncidentStore.filterOptions.filters.length > 0;

    await getData();
};

const getData = async function () {
    await auditIncidentStore.list(props.audit.id);
    await updateData();
};

const uploadDocument = async function () {
    await auditIncidentStore.uploadNarrative(
        selectedIncindentId.value,
        uploadNarrative
    );
    await getData();
    hideUploadNarrative();
    uploadNarrative.value.value = "";
};

onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InformationModal, {
      title: "Reject Narrative",
      "show-modal": isShowNarrativeReviewEditor.value,
      onDismiss: hideNarrativeReviewEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(reviewNarrative, ["prevent"])
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((review.value.comment) = $event)),
                id: "reviewComment",
                class: "form-control"
              }, "\r\n                    ", 512), [
                [_vModelText, review.value.comment]
              ])
            ])
          ]),
          _hoisted_4
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Review Incident",
      "show-modal": isShowIncidentReviewEditor.value,
      onDismiss: hideIncidentReviewEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(reviewIncident, ["prevent"])
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("select", {
                id: "reviewStatus",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((review.value.status) = $event)),
                class: _normalizeClass(["form-select", { 'is-invalid': !!_unref(errors).status}])
              }, _hoisted_10, 2), [
                [_vModelSelect, review.value.status]
              ]),
              (_unref(errors).status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(errors).status), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((review.value.comment) = $event)),
                id: "reviewComment",
                class: "form-control"
              }, "\r\n                    ", 512), [
                [_vModelText, review.value.comment]
              ])
            ])
          ]),
          _hoisted_14
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: uploadNarrativeTitle.value,
      "show-modal": isShowUploadNarrative.value,
      onDismiss: hideUploadNarrative
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("input", {
                  type: "file",
                  ref_key: "uploadNarrative",
                  ref: uploadNarrative,
                  id: "uploadNarrative",
                  class: "form-control"
                }, null, 512)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("button", {
              onClick: _withModifiers(uploadDocument, ["prevent"]),
              class: "btn btn-primary",
              "data-bs-dismiss": "modal"
            }, "Save")
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "show-modal"]),
    _createVNode(InformationModal, {
      title: "Delete",
      "show-modal": isConfirmDialog.value,
      "show-footer": true,
      className: "confirm",
      onDismiss: hideConfirmDialog
    }, {
      footer: _withCtx(() => [
        _hoisted_21,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: deleteIncident
        }, "Yes")
      ]),
      default: _withCtx(() => [
        _createTextVNode(" Are You Sure? ")
      ]),
      _: 1
    }, 8, ["show-modal"]),
    (_ctx.runAudits)
      ? (_openBlock(), _createBlock(AuditJobs, {
          key: 0,
          "run-audits": _ctx.runAudits,
          "create-audits": _ctx.createAudits,
          audit: _ctx.audit,
          id: _ctx.id
        }, null, 8, ["run-audits", "create-audits", "audit", "id"]))
      : _createCommentVNode("", true),
    _hoisted_22,
    _createVNode(BFilterModal, {
      isShowFilterEditor: isShowFilterEditor.value,
      filterOptions: _unref(auditIncidentStore).filterOptions,
      filterableFields: _unref(auditIncidentStore).filterableFields,
      onFilterChanged: applyFilters,
      onDismissModal: handleDismiss
    }, null, 8, ["isShowFilterEditor", "filterOptions", "filterableFields"]),
    _createVNode(BTableHeader, {
      value: _unref(auditIncidentStore).tableOptions,
      onOptionChange: handleOptionChange,
      "header-slot-class": "b-header-slot w-100"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showFilterEditor($event))),
          type: "button",
          class: "btn btn-primary ml-2"
        }, [
          _hoisted_23,
          _createTextVNode(" Filter ")
        ]),
        _renderSlot(_ctx.$slots, "header.toolbar"),
        (hasAppliedFilters.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(filtersDescription.value), 1))
          : _createCommentVNode("", true),
        (hasAppliedFilters.value)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn-close",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (resetFilters()), ["prevent"]))
            }, null, 512)), [
              [_directive_tooltip, 'Remove all currently applied filters.']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["value"]),
    _createVNode(BTable, {
      items: _unref(auditIncidentStore).items,
      columns: columns,
      caption: 'List of errors and warnings',
      value: _unref(auditIncidentStore).tableOptions,
      onOptionChange: handleOptionChange
    }, {
      "cell.incidentNumber": _withCtx(({ item, column }) => [
        _createElementVNode("a", {
          target: "_blank",
          href: `MSIVReportViewer.aspx?IncidentNumber=${item.incidentNumber}&ORI=${item.ori}`
        }, _toDisplayString(item.incidentNumber), 9, _hoisted_25)
      ]),
      "cell.status": _withCtx(({ item, column }) => [
        _createTextVNode(_toDisplayString(item.statusName) + " ", 1),
        (item.comment)
          ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_26, null, 512)), [
              [_directive_tooltip, item.comment]
            ])
          : (item.narrative && item.narrative.Comment)
            ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_27, null, 512)), [
                [_directive_tooltip, item.narrative.Comment]
              ])
            : _createCommentVNode("", true),
        (!item.loadId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" Deleted ")
            ], 64))
          : (item.actionLoadId && item.loadId!=item.actionLoadId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(" Updated ")
              ], 64))
            : _createCommentVNode("", true)
      ]),
      "cell.actions": _withCtx(({ item, column }) => [
        (item.narrative==null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
              (item.status=='NR' && !_ctx.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (showUploadNarrative(item)), ["prevent"])
                  }, " Upload Narrative", 8, _hoisted_29))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("a", {
                class: "btn btn-sm btn-secondary ms-1",
                href: `api/v1/audit/file/${item.narrative.FileId}`
              }, "View Narrative", 8, _hoisted_30),
              (item.narrative.Status!='DA' &&  !_ctx.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showUploadNarrative(item)), ["prevent"])
                  }, " Replace Narrative", 8, _hoisted_31))
                : _createCommentVNode("", true)
            ], 64)),
        (_ctx.runAudits && item.narrative)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (item.narrative.Status=='DU' && item.status=='IN')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-danger btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showNarrativeReviewEditor(item.id)), ["prevent"])
                  }, " Reject Narrative ", 8, _hoisted_32))
                : _createCommentVNode("", true),
              (item.narrative.Status=='DU'  && item.status=='IN')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showIncidentReviewEditor(item.id)), ["prevent"])
                  }, " Review Incident ", 8, _hoisted_33))
                : _createCommentVNode("", true),
              (item.status=='IF'  || item.status=='IP')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showIncidentReviewEditor(item.id)), ["prevent"])
                  }, " Update Review ", 8, _hoisted_34))
                : (_openBlock(), _createElementBlock("span", _hoisted_35))
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_36)),
        (_ctx.runAudits)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: "btn btn-danger btn-sm ms-1",
              onClick: _withModifiers(($event: any) => (deleteItem(item.id)), ["prevent"])
            }, " Delete Request ", 8, _hoisted_37))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["items", "columns", "value"]),
    _createVNode(BTableHeader, {
      value: _unref(auditIncidentStore).tableOptions,
      onOptionChange: handleOptionChange,
      "header-slot-class": "b-header-slot w-100"
    }, null, 8, ["value"])
  ]))
}
}

})